import Vue from 'vue'

export default {
    UPDATE_CHARITY (state, value) {
        Vue.set(state, 'charities', value);
    },
  SET_CHARITIES (state, value) {
        this.commit('UPDATE_CHARITY', value);
    },
    SET_SELECTED_CHARITY (state,  value ) {
      Vue.set(state, 'selectedCharity', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/charities/mutations.js